import { render, staticRenderFns } from "./freight_template_edit.vue?vue&type=template&id=6c572212&scoped=true&"
import script from "./freight_template_edit.vue?vue&type=script&lang=js&"
export * from "./freight_template_edit.vue?vue&type=script&lang=js&"
import style0 from "./freight_template_edit.vue?vue&type=style&index=0&id=6c572212&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c572212",
  null
  
)

export default component.exports